import { Component, Input } from '@angular/core';
import { AbstractInputComponent } from '@shared/form-fields/abstract-value-accessor/abstract-value';
import { makeProvider } from '@shared/form-fields/make-provider';

@Component({
    selector: 'app-file-drop-zone',
    templateUrl: './file-drop-zone.component.html',
    styleUrls: ['./file-drop-zone.component.scss'],
    providers: [makeProvider(FileDropZoneComponent)]
}) export class FileDropZoneComponent extends AbstractInputComponent<File> {

    @Input() acceptTypes: string[] = [];
    @Input() disableDelete = false;
    @Input() hint: string;
    @Input() maxSize!: string;

    public isDragOver = false;
    public previewPending = false;
    public filePreview: string;
    public inputValue: File;

    private reader = new FileReader();
    private fileType: string;

    constructor() {
        super();

        this.reader.onload = () => {
            this.filePreview = null;
            this.previewPending = true;
        };

        this.reader.onloadend = (event) => {
            if (this.fileType.split('/')[0] === 'image') {
                this.filePreview = event.target.result as string;
            }
        };
    }

    addFile(files: FileList) {
        const file = files.item(0);
        this.fileType = file.type;
        this.reader.readAsDataURL(file);
        this.writeValue(file);
    }

    removeFile() {
        this.inputValue = null;
        this.clearValue();
    }

    dragOver(event: DragEvent) {
        event.preventDefault();
        this.isDragOver = true;
    }

    drop(event: DragEvent) {
        event.preventDefault();
        this.isDragOver = false;
        this.addFile(event.dataTransfer.files);
    }
}
